import { Range as ReactRange, getTrackBackground } from 'react-range';
import { useAppDispatch, useAppSelector } from '../../reducers/hooks';
import { Api } from '../../App';
import { ChevronRight } from '@mui/icons-material';
import '../Steps.css';
import { Fragment, useState } from 'react';
import { setDrillCycle, setRigidity, setSpindle, setToolHolder, setToolPath, setMaxFeed, setMaxRPM, maxFeedMMPM, maxFeedIPM, maxRPM } from '../../reducers/machineReducer';
import Dropdown from '../../components/ObjectBrowser/Dropdown/Dropdown';
import { EditableAttributeNumber } from '../../components/ObjectBrowser/ObjectItem/ObjectItem';


// Since this can be loaded at any time, it must be a separate component.
function SpindleSelector({spindle}: {spindle: string}) {
    const [spindles, setSpindles] = useState<any[]|null>(null);
    const dispatch = useAppDispatch();

    if (spindles === null) {
        setSpindles([]);
        Api.getSpindles().then((spindles) => setSpindles(spindles.map((value) => (<option key={value} value={value}>{value}</option>))));
    }
    
    return <>
        {spindles && spindles.length === 0 && <div>Loading spindles...</div>}
        {spindles && spindles.length > 0 && <select value={spindle} onChange={(e) => dispatch(setSpindle(e.target.value))}>
            {spindles}
        </select>}
    </>
}


function MachineStep({dispatchStep, setToolType, toolType}:any) {
    const dispatch = useAppDispatch();
    const machine = useAppSelector((state) => state.machine);
    // Prevent constant refreshing of tools on every tick change
    const [tempRigidity, setTempRigidity] = useState(machine.rigidity);



    return (
        <Fragment>
            <div className="modalNoBlank" style={{backgroundColor: 'transparent'}}>
                <div className="modalContent" style={{overflow: 'visible'}}>
                    <h2>Machining</h2>
                    <div className="editableAttribute">
                        <label>Rigidity ({tempRigidity}/10)</label>
                        <ReactRange
                            min={0}
                            max={10}
                            step={1}
                            values={[tempRigidity]}
                            onChange={(values:number[]) => setTempRigidity(values[0])}
                            onFinalChange={(values:number[]) => dispatch(setRigidity(values[0]))}
                            renderTrack={({ props, children }) => (
                                <div
                                    onMouseDown={props.onMouseDown}
                                    onTouchStart={props.onTouchStart}
                                    className="rangeSlider"
                                    style={{
                                        ...props.style,
                                        height: "36px",
                                        display: "flex",
                                    }}
                                >
                                    <div
                                        ref={props.ref}
                                        style={{
                                            height: "5px",
                                            width: "100%",
                                            maxWidth: "300px",
                                            borderRadius: "4px",
                                            background: getTrackBackground({
                                                values: [tempRigidity],
                                                colors: ["var(--primary)", "#959595"],
                                                min: 0,
                                                max: 10
                                            }),
                                            alignSelf: "center"
                                        }}
                                    >
                                        {children}
                                    </div>
                                </div>
                            )}
                            renderThumb={({ props }) => (
                                <div
                                    {...props}
                                    style={{
                                    ...props.style,
                                    height: '20px',
                                    width: '10px',
                                    backgroundColor: 'var(--primary)'
                                    }}
                                />
                            )}
                        />
                    </div>
                    <div className="editableAttribute">
                        <label>Spindle </label>
                        <SpindleSelector spindle={machine.spindle} />
                    </div>
                    <div className="editableAttribute">
                        <label>Tool Holder </label>
                        <select value={machine.toolHolder} onChange={(e) => dispatch(setToolHolder(e.target.value))}>
                            {Api.getToolHolders().map(path => <option key={path.value} value={path.value}>{path.name}</option>)}
                        </select>
                    </div>
                    {EditableAttributeNumber({
                        label: 'Max Speed',
                        key: 'maxRPM',
                        attributes: machine,
                        originalAttributes: {maxRPM: maxRPM},
                        setAttributes: (machine: any) => dispatch(setMaxRPM(machine.maxRPM)),
                        unit: 'RPM',
                        validation: (value) => value <= 0 ?
                            'Max Speed must be greater than 0' : ''
                    })}
                    {EditableAttributeNumber({
                        label: 'Max Feed',
                        key: 'maxFeed',
                        attributes: machine,
                        originalAttributes: {maxFeed: Api.units === 'INCH' ? maxFeedIPM : maxFeedMMPM},
                        setAttributes: (machine: any) => dispatch(setMaxFeed(machine.maxFeed)),
                        unit: Api.displayPreferredUnits('feed'),
                        validation: (value) => value <= 0 ?
                            'Max Feed must be greater than 0' : ''
                    })}
                    <hr />
                    <h2>
                        <span>I am </span>
                        <select value={toolType || ""} onChange={(e) => setToolType(e.target.value)}>
                            <option value=""></option>
                            <option value="endmills">milling</option>
                            <option value="drills">drilling</option>
                        </select>
                        <span> this material</span>
                    </h2>
                    {
                        toolType === 'endmills' && (
                        <div>
                            <div className="editableAttribute">
                                <label>Tool Path</label>
                                <Dropdown
                                    options={Api.getToolPaths()}
                                    dropdownValue={machine.toolPath}
                                    placeholder="Tool Path"
                                    setDropdownValue={(value:string) => dispatch(setToolPath(value))}
                                />
                                { machine.toolPath === 'hem' && ( <div className="error">NOTE: Results will be VoluMill-specific</div> ) }
                            </div>
                        </div>)
                    }
                    {
                        toolType === 'drills' && (
                            <div>
                                <div className="editableAttribute">
                                    <label>Drill Cycle</label>
                                    <Dropdown
                                        options={Api.getDrillCycles()}
                                        dropdownValue={machine.drillCycle}
                                        placeholder="Drill Cycle"
                                        setDropdownValue={(value:string) => dispatch(setDrillCycle(value))}
                                    />
                                </div>
                            </div>)
                    }
                    <hr />
                    {
                        toolType && (
                            <div className="btn primaryBtn" onClick={() => dispatchStep('+')}>
                                <span>Select {toolType === 'endmills' ? 'Endmill' : 'Drill'}</span>
                                <ChevronRight />
                            </div>
                        )
                    }
                    
                </div>
            </div>
        </Fragment>
    )
}

export default MachineStep;